import { render, staticRenderFns } from "./MemberGradeTags.vue?vue&type=template&id=66c30db5"
import script from "./MemberGradeTags.vue?vue&type=script&lang=js"
export * from "./MemberGradeTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports